import { useState } from 'react';
import './ShareLinkModal.css';

const EXPIRY_OPTIONS = [
  { label: '1 uur',  value: 3600 },
  { label: '6 uur', value: 21600 },
  { label: '24 uur', value: 86400 },
  { label: '3 dagen',  value: 259200 },
  { label: '7 dagen',  value: 604800 },
];

const CHARS = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789!@#$';
function randomPassword(length) {
  return Array.from({ length }, () => CHARS[Math.floor(Math.random() * CHARS.length)]).join('');
}

export default function ShareLinkModal({ docId, onClose }) {
  const [pwLength, setPwLength]       = useState(12);
  const [password, setPassword]       = useState(() => randomPassword(12));
  const [expiry, setExpiry]           = useState(86400);
  const [generatedToken, setGeneratedToken] = useState(null);
  const [copied, setCopied]           = useState(false);
  const [loading, setLoading]         = useState(false);
  const [error, setError]             = useState(null);

  const regenerate = (len) => {
    const l = Math.min(32, Math.max(6, parseInt(len, 10) || 12));
    setPwLength(l);
    setPassword(randomPassword(l));
  };

  const generate = async () => {
    setLoading(true); setError(null);
    try {
      const res  = await fetch(`/api/documents/${docId}/share`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ password, expiresInSeconds: expiry }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setGeneratedToken(data.token);
    } catch (e) { setError(e.message); }
    setLoading(false);
  };

  const shareUrl = generatedToken ? `${window.location.origin}/doc/${generatedToken}` : null;

  const copyAll = () => {
    navigator.clipboard.writeText(`Link: ${shareUrl}\nWachtwoord: ${password}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <div className="share-modal-overlay" onClick={onClose}>
      <div className="share-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Document Delen</h3>

        {!generatedToken ? (
          <>
            <div className="share-field">
              <label>Wachtwoord</label>
              <div className="pw-row">
                <input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Wachtwoord"
                />
                <input
                  className="pw-length"
                  type="number"
                  min="6"
                  max="32"
                  value={pwLength}
                  onChange={(e) => regenerate(e.target.value)}
                  title="Wachtwoordlengte"
                />
              </div>
            </div>

            <div className="share-field">
              <label>Link verloopt over</label>
              <select value={expiry} onChange={(e) => setExpiry(Number(e.target.value))}>
                {EXPIRY_OPTIONS.map((o) => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>

            {error && <p className="share-error">{error}</p>}

            <div className="share-actions">
              <button className="share-btn secondary" onClick={onClose}>Annuleren</button>
              <button className="share-btn primary" onClick={generate} disabled={loading}>
                {loading ? 'Bezig met genereren…' : 'Link Genereren'}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="link-box">{shareUrl}</div>
            <div className="pw-display">Wachtwoord: <strong>{password}</strong></div>
            <button className="share-btn primary full" onClick={copyAll}>
              {copied ? '✓ Gekopieerd!' : 'Link + Wachtwoord Kopiëren'}
            </button>
            {copied && <p className="copied-note">Link en wachtwoord gekopieerd naar klembord</p>}
            <div className="share-actions">
              <button className="share-btn secondary" onClick={onClose}>Klaar</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
